export function translateContractsGroupsListToOptions(contractsGroupList) {
    return contractsGroupList.reduce(
        (list, grupo) => [
            ...list,
            ...grupo.contratos.map((contrato) => ({
                ...contrato,
                codigo: contrato.numeroContrato,
                nome: `${contrato.numeroContrato} - ${contrato.nomeContrato}`,
            })),
        ],
        []
    );
}
